import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import Icons from "shared/icons";

const classificationValues = ["cost_type", "total_amount", "date"];

function OCRClassifications({ classifications }) {
  const { t } = useTranslation("OCR");
  const allClissified = Object.values(classifications).every(
    (value) => value !== null
  );
  return (
    <div className="px-4 pt-4 text-primary">
      <strong>
        {allClissified ? (
          t("automatically_entered_data")
        ) : (
          <span className="text-danger">
            <FontAwesomeIcon
              icon={Icons.triangleExclamation}
              className="me-2"
            />{" "}
            {t("unable_to_fetch_the_data")}
          </span>
        )}
      </strong>
      <ul className="mt-3 ps-2" style={{ listStyleType: "none" }}>
        {classificationValues.map((value) => {
          const cv = classifications[value];
          return (
            <li key={value}>
              {t(value)}
              {cv ? (
                <strong className="text-success">{cv}</strong>
              ) : (
                <strong className="text-danger">{t("provide_manualy")}</strong>
              )}
            </li>
          );
        })}
      </ul>
      <strong>{t("warning")}</strong>
    </div>
  );
}

export default OCRClassifications;
